module.exports = function() {
  return new Worker(__webpack_public_path__ + "0e2ce3cbe75d54cf101c.worker.js");
};